import React from 'react';
import sampleIcon from '../../assets/flask.svg'
import listIcon from '../../assets/list-white.svg'
import uploadIcon from '../../assets/upload-image-icon.svg'
import deleteIcon from '../../assets/delete-white.svg'
import editIcon from '../../assets/edit-white.svg'
import expandIcon from '../../assets/expand.svg'
import collapseIcon from '../../assets/collapse.svg'
import {
    Input,
    Button,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Col,
    Form,
    CustomInput
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import ReactTable from "react-table";
import { connect } from "react-redux";
import {
    fetchSamplesList,
    fetchLocationList,
    saveSample,
    updateSample,
    getLocation,
    deleteMultipleSamples
} from '../../actions';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faArrowsAltV} from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/Pagination/pagination'
import moment from 'moment';
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-toastify/dist/ReactToastify.css";
import '../../components/Overlay/overlay.css';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';

const initialState = {
    sample_id: "",
    organism: "",
    location: "",
    date_time: null,
    comments: "",
    typeofSamples: "",
    typeofAnalysis: "",
    isDeleteModalOpen: false,
    fileName: "",
    pictureFile: "",
    batchNumber: "",
    barcode: "",
    isDisable: false,
    edit: false,
    isEditModalOpen: false,
    isEditBarcodeModelOpen: false,
    searchSample: "",
    referenceGenome: "",
    unit: "",
    editunit: "",
    toggle: false,
    checked: [],
}

const buildingInitialChange = {
    building_name: "",
    floor_name: "",
    room: ""
}

let errorDetails = ""
let editSampleId = ""

class OverLay extends React.Component {
    constructor(props) {
        super(props)
        initialState["location"] = this.props.locationId ? this.props.locationId : ""
        initialState["filter_date_time"] = this.props.date_time ? this.props.date_time : ""
        this.props.getLocation(initialState["location"]).then(response => {
            if (response.status === 200 && response.data) {
                appInsights.trackTrace({message: 'Location is fetched successfully', properties:{page: "overlay", name: response.data.description, id: initialState["location"]}, severityLevel: SeverityLevel.Information});
                this.setState(prevState => ({
                    location_description: response.data.description,
                    room: response.data.room.room_name,
                    floor_name: response.data.floor.floor_name,
                    building_name: response.data.floor.building.building_name,
                    unitList: response.data.units,
                    floor: response.data.floor.id,
                    building: response.data.floor.building.id
                })
                )
            }
            else {
                let message = "Location does not exist!"
                appInsights.trackTrace({message: message, properties:{page: "overlay", id: initialState["location"]}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        })

        this.fetchSamples(initialState["location"], initialState["filter_date_time"])

        this.saveData = this.saveData.bind(this)
        this.resetData = this.resetData.bind(this)
        this.validateData = this.validateData.bind(this)
        this.ErrorDetails = this.ErrorDetails.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onChange = this.onChange.bind(this)
        this.deleteMultipleSamples = this.deleteMultipleSamples.bind(this)
        Object.assign(buildingInitialChange, initialState);
        this.state = buildingInitialChange
    }

    fetchSamples = (location, date, analysis) => {
        let utc_date = (date === "" || date === undefined || date === null) ? "" : (moment(new Date(date)).format('YYYY-MM-DD'))
        this.props.fetchSamplesList({
            date_time: utc_date,
            location_id: location,
            is_result_generated: false,
            type_of_analysis: analysis
        })
    }

    columns = [
        {
            accessor: 'id',
            headerClassName: "not-visible",
            className: "not-visible",
            width: 0
        },
        {
            Header: 'Sample ID',
            accessor: 'sample_id',
            headerClassName: "not-visible",
            className: "not-visible",
            width: 0
        },
        {
            Header: state => (
                <CustomInput type="checkbox" 
                className="custom-selectall-checkbox"
                id="overlay-all-samples"
                checked={this.props.sampleList.length===this.state.checked.length}
                intermediate={this.state.checked.length!==0 && this.props.sampleList.length>this.state.checked.length}
                onClick={() => this.selectAll()}/>
                ),
            id: 'checkbox',
            accessor: str => "checkbox",
            Cell: (row) => {
                let checked = this.state.checked.includes(row.index)
                return <CustomInput type="checkbox" className={checked?"custom-table-checkbox select-checked":"custom-table-checkbox"} id={row.original.id} checked={checked} onClick={() => this.handleCheckClick(row.index)}/>
            },
            width: 50,
            headerClassName: 'checkbox-sticky-style',
            className: 'checkbox-sticky-style',
            filterable:false,
        },
        {
            Header: 'Barcode',
            accessor: 'barcode',
            Cell: (row) => {
                if (row.original.parent !==null && row.original.parent !==undefined) {
                    return <>{row.original.barcode +" "}<FontAwesomeIcon title={"Child sample of " + row.original.parent.sample_id} className="sample-parent"  icon={faArrowsAltV} size="lg" ></FontAwesomeIcon></>
                }
                else {
                    return <>{row.original.barcode}</>
                }
            },
            width: 180,
        },
        {
            Header: 'Batch Number',
            accessor: 'batch_no',
            width: 180
        },
        {
            Header: 'Location ID / Unit ID',
            id: 'location',
            accessor: str => "location",
            Cell: (row) => {
                if (row.original.unit) {
                    return <div>{(row.original.location.location_id || row.original.location) + '_' + (row.original.unit.unit_id || row.original.unit)}</div>
                }
                else {
                    return <div>{row.original.location.location_id || row.original.location}</div>
                }
            },
            width: 180
        },
        {
            Header: 'Date & Time',
            accessor: 'date_time',
            Cell: (props) => {
                let date = new Date(props.value)
                date = moment(date).format('MMM D, YYYY HH:mm')
                return <span>{date}</span>
            },
            width: 180
        },
        {
            Header: 'Organism',
            accessor: 'organism',
            width: 120
        },
        {
            Header: 'Type of Sample',
            accessor: 'type_of_samples',
            width: 150
        },
        {
            Header: 'Type of Analysis',
            accessor: 'type_of_analysis',
            width: 130
        },
        {
            Header: 'Reference Genome',
            accessor: 'reference_genome',
            width: 150
        },
        {
            Header: 'Comments',
            accessor: 'comments',
            headerClassName: "not-visible",
            className: "not-visible",
            width: 0
        },
        {
            Header: 'Image',
            accessor: 'picture',
            Cell: (row) => (
                <a href="#sample" onClick={() => {
                    if (row.original.picture){
                        var image = new Image()
                        image.src = row.original.picture[1]
                        var win = window.open("");
                        win.document.write(image.outerHTML);
                    }
                }}>{this.pictureData(row.original.picture)}</a>
            ),
            headerClassName: "not-visible",
            className: "not-visible",
            width: 0
        },
    ]

    handleCheckClick = (value) =>{
        this.setState(prevState => ({
            checked: prevState.checked.includes(value)?[...prevState.checked.filter((val) => val !== value)]:[...prevState.checked, value],
        }))
    }

    selectAll = () => {
        this.setState({
        checked: this.state.checked.length < this.props.sampleList.length?[...Array(this.props.sampleList.length).keys()]:[]})
    }

    handleEditBarcode = () => {
        let message = ''
        if(this.state.editbarcode !==this.state.currentBarcode){
            message = <div>Barcode is changed from <i>{this.state.currentBarcode}</i> to <i>{this.state.editbarcode}</i>. Are you sure you want to proceed?</div>
        }
        message?this.setState(prevState => ({
            isEditBarcodeModelOpen: true,
            warningMessage: message
        })): this.saveData()
    }

    toggleEditBarcodeModal = () =>{
        this.setState(prevState => ({
            isEditBarcodeModelOpen: false,
            warningMessage: ''
        }))
    }

    toggleSamples  = () =>{
        this.setState(prevState => ({
            toggle: !prevState.toggle,
        }))
    }
    pictureData = (data) => {
        var fileName = ""
        if (data != null) {
            fileName = data[0]
        }
        return fileName
    }

    deleteMultipleSamples = () => {
        let ids = this.state.checked.map((data) => this.props.sampleList[data].id)
        this.props.deleteMultipleSamples(ids).then(response => {
            if (response.status === 204) {
                let message = "Samples Deleted Successfully!"
                appInsights.trackEvent({name: 'Samples Deleted', properties:{page: "overlay", id: ids}});
                appInsights.trackTrace({message: message,  properties:{page: "overlay", id: ids}, severityLevel: SeverityLevel.Information})
                toast.success(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
            else {
                let message = "Samples couldn't be deleted!"
                appInsights.trackTrace({message: message,  properties:{page: "overlay", id: ids}, severityLevel: SeverityLevel.Error})
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
            this.resetData()
        }).catch(() => {
            let message = "Sample couldn't be deleted!"
            appInsights.trackTrace({message: message, properties: {id: ids}, severityLevel: SeverityLevel.Error});
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
            this.resetData()
        })
    }

    toggleDeleteModal = () => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
        }));
    }

    toggleEditModal = (data) => {
        this.setState(prevState => ({
            isEditModalOpen: !prevState.isEditModalOpen,
        }))
        return data.sample_id ? this.modifySample(data) : null
    }

    onChange = date => {
        return this.setState({ date_time: date })
    };

    onChangeDate = date => {
        return this.setState({ editdate_time: date })
    }

    onFilterDateChange = date => {
        this.setState({ filter_date_time: date }, () => {
            this.fetchSamples(this.state.location, this.state.filter_date_time)
        })
    }

    handleChange(event) {
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        })
    };

    saveData = () => {
        if (this.validateData(this.state)) {
            let organism = this.state.organism ? this.state.organism[0].toUpperCase() + this.state.organism.substr(1, this.state.organism.length).toLowerCase() : ""
            if (this.state.edit) {
                if (editSampleId === this.state.sample_id) {
                    editSampleId = ""
                    this.setState({
                        isDisable: false,
                        edit: false
                    })
                    organism = this.state.editOrganism ? this.state.editOrganism[0].toUpperCase() + this.state.editOrganism.substr(1, this.state.editOrganism.length).toLowerCase() : ""
                    var data = {
                        id: this.state.id,
                        sample_id: this.state.sample_id,
                        organism: organism,
                        location: this.state.location,
                        unit: this.state.editunit,
                        date_time: this.state.editdate_time,
                        comments: this.state.editComments,
                        type_of_analysis: this.state.edittypeofAnalysis,
                        type_of_samples: this.state.edittypeofSamples,
                        batch_no: this.state.editbatchNumber,
                        barcode: this.state.editbarcode,
                        is_result_generated: false,
                        reference_genome: this.state.edittypeofAnalysis === "SNP" ? this.state.editreferenceGenome : ""
                    }
                    if (this.state.editpictureFile != null) {
                        if (this.state.editpictureFile.type.split("/")[0] === "image") {
                            data.picture = this.state.editpictureFile
                        }
                    }
                    this.props.updateSample({
                        data
                    }).then(response => {
                        if (response.status === 200) {
                            let message = "Sample List Updated Successfully!"
                            appInsights.trackEvent({name: 'Sample Updated', properties:{page: "overlay", id: response.data.barcode}});
                            appInsights.trackTrace({message: 'Sample Updated', properties:{page: "overlay", id: response.data.barcode}, severityLevel: SeverityLevel.Information})
                            toast.success(message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            });
                        }
                        else {
                            let message = "Sample List couldn't be updated!"
                            appInsights.trackTrace({message: message, properties:{page: "overlay", id: this.state.editbarcode}, severityLevel: SeverityLevel.Error})
                            toast.error(message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            });
                        }
                        this.resetData()
                    })
                        .catch((error) => {
                            let message = "Sample couldn't be updated!"
                            appInsights.trackTrace({message: message, properties:{page: "overlay", id: this.state.editbarcode, error: error}, severityLevel: SeverityLevel.Error})
                            toast.error( message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            })
                            this.resetData()
                        })
                }
                else {
                    let message = "Sample ID can't be updated while editing!"
                    appInsights.trackTrace({message: message, properties:{page: "overlay"}, severityLevel: SeverityLevel.Verbose})
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }
            else {
                this.props.saveSample({
                    organism: organism,
                    location: this.state.location,
                    unit: this.state.unit,
                    date_time: this.state.date_time,
                    comments: this.state.comments,
                    type_of_analysis: this.state.typeofAnalysis,
                    type_of_samples: this.state.typeofSamples,
                    picture: this.state.pictureFile,
                    batch_no: this.state.batchNumber,
                    barcode: this.state.barcode,
                    reference_genome: this.state.typeofAnalysis === "SNP" ? this.state.referenceGenome : ""
                }).then(response => {
                    if (response.status === 201) {
                        let message = "Sample Added Successfully!"
                        appInsights.trackEvent({name: 'Sample Created', properties:{page: "overlay", id: response.data.barcode}});
                        appInsights.trackTrace({message: 'Sample Created', properties:{page: "overlay", id: response.data.barcode}, severityLevel: SeverityLevel.Information})
                        toast.success(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                    else {
                        let message = "Sample List couldn't be added!"
                        appInsights.trackTrace({message: message, properties:{page: "overlay", id: this.state.barcode}, severityLevel: SeverityLevel.Error})
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                    this.resetData()
                })
                    .catch((error) => {
                        let errors = error.response.data
                        if (errors && errors.barcode) {
                            let message = "Sample with this Barcode already exists !"
                            appInsights.trackTrace({message: message, properties:{page: "overlay", id: this.state.barcode, error: error}, severityLevel: SeverityLevel.Error})
                            toast.error(message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            })
                        }
                        else {
                            let message = "Sample couldn't be added !"
                            appInsights.trackTrace({message: message, properties:{page: "overlay", id: this.state.barcode, error: error}, severityLevel: SeverityLevel.Error})
                            toast.error(message, {
                                position: toast.POSITION.BOTTOM_RIGHT
                            })
                        }
                        this.resetData()
                    })
            }
        }
        else {
            this.ErrorDetails()
        }
    }

    ErrorDetails = () => {
        appInsights.trackTrace({message: errorDetails, properties:{page: "overlay"}, severityLevel: SeverityLevel.Verbose})
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    resetData = () => {
        this.setState( prevState => ({
            ...initialState,
            toggle: prevState.toggle,
            filter_date_time: prevState.filter_date_time
        }), () => {
            this.fetchSamples(this.state.location, this.state.filter_date_time)
            this.props.applyOnFLoor()
        })
    }

    cancelDate = () => {
            this.setState({filter_date_time: ""}, () => {
                this.fetchSamples(this.state.location, this.state.filter_date_time)
            })
    }

    validateData = (data) => {
        let isValidDate = moment(data.date_time).isValid()
        let isvalidEditDate = moment(data.editdate_time).isValid()
        if (data.edit) {
            if ((data.barcode.trim().length === 0 && isValidDate && data.location.length === 0 && data.organism.trim().length === 0 && data.referenceGenome.trim().length === 0) && (data.edit && data.editbarcode.trim().length === 0 && isvalidEditDate && data.editlocation.length === 0 && data.editOrganism.trim().length === 0 && data.editreferenceGenome.trim().length === 0)) {
                errorDetails = "All *mandatory fields are required to save Sample data"
                return false
            }
        }
        else {
            if ((data.barcode.trim().length === 0 && isValidDate && data.location.length === 0 && data.organism.trim().length === 0 && data.referenceGenome.trim().length === 0) || (data.edit && data.editbarcode.trim().length === 0 && isvalidEditDate && data.editlocation.length === 0 && data.editOrganism.trim().length === 0 && data.editreferenceGenome.trim().length === 0)) {
                errorDetails = "All *mandatory fields are required to save Sample data"
                return false
            }
        }
        if ((data.barcode.trim().length > 0 && isValidDate && data.location.length > 0 && data.organism.trim().length > 0 && ((data.typeofAnalysis === "SNP" && data.referenceGenome.trim().length > 0) || (data.typeofAnalysis !== "SNP"))) || (data.edit && data.editbarcode.trim().length > 0 && isvalidEditDate && data.editlocation.length > 0 && data.editOrganism.trim().length > 0 && ((data.edittypeofAnalysis === 'SNP' && data.editreferenceGenome.trim().length > 0) || (data.edittypeofAnalysis !== 'SNP')))) {
            return true
        }
        else if ((data.barcode.trim().length > 0 && isValidDate && data.location.length > 0 && data.organism.trim().length > 0 && data.typeofAnalysis === "SNP" && data.referenceGenome.trim().length === 0) || (data.edit && data.editbarcode.trim().length > 0 && isvalidEditDate && data.editlocation.length > 0 && data.editOrganism.trim().length > 0 && data.edittypeofAnalysis === 'SNP' && data.editreferenceGenome.trim().length === 0)) {
            errorDetails = "Reference Genome is empty"
            return false
        }
        else if ((data.barcode.trim().length > 0 && isValidDate && data.organism.trim().length > 0 && data.referenceGenome.trim().length > 0 && data.location.length === 0) || (data.edit && data.editbarcode.trim().length > 0 && isvalidEditDate && data.editOrganism.trim().length > 0 && data.editreferenceGenome.trim().length > 0 && data.editlocation.length === 0)) {
            errorDetails = "Select the Location from the dropdown"
            return false
        }
        else if ((isValidDate && data.organism.trim().length > 0 && data.referenceGenome.trim().length > 0 && data.location.length > 0 && data.barcode.trim().length === 0) || (data.edit && isvalidEditDate && data.editOrganism.trim().length > 0 && data.editreferenceGenome.trim().length > 0 && data.editlocation.length > 0 && data.editbarcode.trim().length === 0)) {
            errorDetails = "Barcode value is empty"
            return false
        }
        else if ((data.barcode.trim().length > 0 && isValidDate && data.referenceGenome.trim().length > 0 && data.location.length > 0 && data.organism.trim().length === 0) || (data.edit && isvalidEditDate && data.editreferenceGenome.trim().length > 0 && data.editlocation.length > 0 && data.editbarcode.trim().length > 0 && data.editOrganism.trim().length === 0)) {
            errorDetails = "Organism value is empty"
            return false
        }
        else if ((data.barcode.trim().length > 0 && data.referenceGenome.trim().length > 0 && data.location.length > 0 && data.organism.trim().length > 0 && !isValidDate) || (data.edit && data.editreferenceGenome.trim().length > 0 && data.editlocation.length > 0 && data.editbarcode.trim().length > 0 && data.editOrganism.trim().length > 0 && !isvalidEditDate)) {
            errorDetails = "Date entered is not valid"
            return false
        }
        else {
            errorDetails = "All *mandatory fields are required to save Sample data"
            return false
        }

    }

    handleFileChange({ target: { files } }) {
        if (files.length !== 0) {
            this.setState({
                fileName: files[0].name,
                pictureFile: files[0]
            })
        }
    }

    handleEditFileChange({ target: { files } }) {
        if (files.length !== 0) {
            this.setState({
                editfileName: files[0].name,
                editpictureFile: files[0]
            })
        }
    }

    modifySample = (data) => {
        let date = new Date(data.date_time)
        editSampleId = data.sample_id
        let unit
        if (data.unit) {
            unit = data.unit.id
        }

        this.setState({
            "id": data.id,
            "sample_id": data.sample_id,
            "editOrganism": data.organism,
            "currentBarcode": data.barcode,
            "editunit": data.unit ? unit : "",
            "editlocation_id": data.location.location_id,
            "editlocation": data.unit ? data.location.location_id + ',' + unit : data.location.location_id,            
            "editdate_time": date,
            "editComments": data.comments,
            "edittypeofSamples": data.type_of_samples,
            "edittypeofAnalysis": data.type_of_analysis,
            "editfileName": this.pictureData(data.picture),
            "editpictureFile": data.picture,
            "editbatchNumber": data.batch_no,
            "editbarcode": data.barcode,
            "editreferenceGenome": data.reference_genome,
            "isDisable": true,
            "edit": true
        })
    }

    clicked = () => {
        this.props.history.push("/samples/floormap/", { floor: this.state.floor, building: this.state.building })
    }

    status = (lastone) =>{
    return (
        <Col sm={2} md={2} lg={2}>
            <div className='overlay-circle-line'>
                <div id="outer-circle">
                    <div id="inner-circle">
                    </div>
                </div>
                <div id="line" />
                <div id="outer-circle" className={lastone?"last-circle":""}>
                    <div id="inner-circle" className={lastone?"last-circle":""}>
                    </div>
                </div>
            </div>
        </Col>
    )}

    render() {
        return (
            <Modal isOpen={this.props.overlayOpen} toggle={this.props.toggleOverlayModal} className="overlay-modal">
                <ModalHeader toggle={this.props.toggleOverlayModal} className="edit-popup">
                    <div className='sample-left-align'><img src={sampleIcon} alt='' className='nav-icons'/> Add Sample</div>
                    <Row form className='overlay-header-content'>
                        <Col sm={2} md={2} lg={2}>
                            <div className="sample-content-title">{this.state.building_name}</div>
                        </Col>
                        {this.status()}
                        <Col sm={2} md={2} lg={2}>
                            <div className="sample-content-title">{this.state.floor_name}</div>
                        </Col>
                        {this.status(true)}
                        <Col sm={4} md={2} lg={2}>
                        <div className="sample-content-title sample-storng-title">{this.state.room}</div>
                        </Col>
                    </Row>
                </ModalHeader>
                <ModalBody>
                    <div>
                        <div>
                            <div>
                                <h5 className="samples-heading">Add Sample</h5>
                                <Row form>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className="overlay-inputs" type="text" name="location" value={this.state.location} onChange={this.handleChange} disabled={true}>
                                        </Input>
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className={this.state.unit ? "overlay-inputs overlay-selected": "overlay-inputs overlay-select" } type="select" name="unit" value={this.state.unit} onChange={this.handleChange}>
                                            <option value="" default className='overlay-default-option'>Select Unit</option>
                                            {this.state.unitList ? this.state.unitList.map((unit, key) => {
                                                return <option className="dashboard-options" key={key} value={unit.id}>{unit.description}</option>
                                            }) : null}
                                        </Input>
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <div>
                                            <DatePicker id="" onChange={this.onChange} selected={this.state.date_time}
                                                filterDate={(date) => {
                                                    return moment() > date;
                                                }}
                                                placeholderText="Date*"
                                                maxDate={new Date()}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                timeIntervals={15}
                                                timeCaption="time"
                                                className="overlay-inputs form-control"
                                                wrapperClassName="datepicker-wrapper"
                                                popperClassName="datepicker-popper"
                                                dateFormat="MMMM d, yyyy HH:mm" />
                                        </div>
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className="overlay-inputs" type="text" name="barcode" value={this.state.barcode} onChange={this.handleChange} placeholder="Barcode*" />
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className="overlay-inputs" type="text" name="typeofSamples" id="SampleType" value={this.state.typeofSamples} onChange={this.handleChange} placeholder="Type of Sample" />
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className="overlay-inputs" type="text" name="organism" id="Organism" value={this.state.organism} onChange={this.handleChange} placeholder="Organism*" />
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className={this.state.typeofAnalysis ? "overlay-inputs overlay-selected": "overlay-inputs overlay-select" } type="select" name="typeofAnalysis" id="AnalysisType" value={this.state.typeofAnalysis} onChange={this.handleChange}>
                                            <option value="" default className='overlay-default-option'>Type of Analysis</option>
                                            <option className="dashboard-options" value="SNP" >SNP</option>
                                            <option className="dashboard-options" value="cgMLST" >cgMLST</option>
                                            <option className="dashboard-options" value="Microbiome" >Microbiome</option>
                                            <option className="dashboard-options" value="Other" >Other</option>
                                        </Input>
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input disabled={this.state.typeofAnalysis !== "SNP"} className="overlay-inputs" type="text" name="referenceGenome" id="referenceGenome" value={this.state.typeofAnalysis === "SNP" ? this.state.referenceGenome : ""} onChange={this.handleChange} placeholder="Reference Genome*" />
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className="overlay-inputs" type="text" name="batchNumber" id="BatchNo" value={this.state.batchNumber} onChange={this.handleChange} placeholder="Batch Number" />
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                        <Input className="overlay-inputs" type="text" name="comments" value={this.state.comments} onChange={this.handleChange} placeholder="Comments" />
                                    </Col>
                                    <Col sm={4} md={3} lg={2}>
                                    <label for="overlay-image-upload" className='overlay-upload-label'>
                                            <img src={uploadIcon} id="image-upload-label" alt=''/> 
                                            <span className='upload-image' title={this.state.fileName || 'Upload Image'}>{this.state.fileName || 'Upload Image'}</span>
                                        </label>
                                        <Input
                                            type="file"
                                            id="overlay-image-upload"
                                            className="overlay-upload-file"
                                            accept=".png,.jpg, .jpeg"
                                            onChange={(e) => this.handleFileChange(e)}
                                            data-title={this.state.fileName || 'Upload Image'}
                                        />
                                    </Col>
                                    <Col sm={4} md={3} lg={2} className="overlay-flex">
                                        <Button className="button-size overlay-cancel-button" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                        <Button className="button-size overlay-save-button" type="submit" onClick={this.saveData}>Save</Button>
                                    </Col>
                                </Row>
                            </div>
                                <Row className="sample-count-wrapper">
                                    <div className='overlay-content-start'>
                                        <div><img src={listIcon} className="nav-icons" alt=''/>List of samples in the Room</div>
                                        <div className="sample-count">{" Total Sample Collected : " + (this.props.sampleList ?this.props.sampleList.length: 0)}</div>
                                    </div>
                                    <Col className={"overlay-header-center"+(this.state.toggle?" overlay-options-enabled":"")}>
                                    {this.state.toggle?<>
                                        <DatePicker id="" onChange={this.onFilterDateChange} selected={this.state.filter_date_time}
                                            filterDate={(date) => {
                                                return moment() > date;
                                            }}
                                            maxDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            placeholderText="Date"
                                            className="form-control overlay-inputs overlay-header-date"
                                            popperClassName="datepicker-popper"
                                            dateFormat="MMMM d, yyyy" />
                                        <div className={this.state.checked.length>0?'overlay-table-selections':"overlay-table-selections overlay-disabled"} data-tut="reactour__tableDelete" onClick={this.state.checked.length>0?this.toggleDeleteModal:undefined}>
                                            <img src={deleteIcon} className='nav-icons' alt=""/>Delete
                                        </div>
                                        <div className={this.state.checked.length===1?'overlay-table-selections':"overlay-table-selections overlay-disabled"} data-tut="reactour__tableEdit" onClick={this.state.checked.length===1?() => this.toggleEditModal(this.props.sampleList[this.state.checked[0]]):undefined}>
                                            <img src={editIcon} className='nav-icons' alt=""/>Edit
                                        </div>
                                        </>:null}
                                    </Col>
                                    <div className='overlay-table-selections overlay-header-end' onClick={this.toggleSamples}><img src={this.state.toggle?collapseIcon:expandIcon} alt=""/></div>
                                </Row>
                            {this.state.toggle?
                            <div className="overlay-data">
                                {this.props.sampleList.length > 0 ?
                                    <div>
                                        <div className='sample-table-height overlay-table'>
                                            <ReactTable className="Data-Table"
                                                PaginationComponent={Pagination}
                                                data={this.props.sampleList}
                                                columns={this.columns}
                                                showPagination={true}
                                                defaultPageSize = {5}
                                                minRows={0}
                                                getTrProps={(state, rowInfo) => {
                                                    if (rowInfo && rowInfo.row) {
                                                      return {
                                                        onClick: () => { this.handleCheckClick(rowInfo.index) },
                                                        className: this.state.checked.includes(rowInfo.index) ? "table-selected-row" : "",
                                                      }
                                                    }else{
                                                      return {}
                                                    }
                                                  }
                                                }
                                                sortable={false}
                                            />
                                        </div>
                                    </div>
                                    : <div className="no-data-msg"> No Samples Available</div>
                                }
                            </div>
                            :null}
                        </div>

                        <Modal isOpen={this.state.isDeleteModalOpen} toggle={this.toggleDeleteModal}>
                            <ModalHeader toggle={this.toggleDeleteModal}>Delete Sample</ModalHeader>
                            <ModalBody>
                                Are you sure you want to delete the selected samples?
                                <div className="float-sm-right mt-3">
                                    <Button className="custom-button cancel-button mr-2" outline color="secondary" onClick={this.toggleDeleteModal}>Cancel</Button>
                                    <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.deleteMultipleSamples}>Delete</Button>
                                </div>
                            </ModalBody>
                        </Modal>
                        <Modal isOpen={this.state.isEditModalOpen} toggle={this.toggleEditModal}>
                            <ModalHeader toggle={this.toggleEditModal} className="edit-popup">Edit a Sample
                            </ModalHeader>
                            <ModalBody>
                                <Form>
                                    <FormGroup>
                                        <div>
                                            <Row form>
                                                <Col>
                                                    <Label className="edit-label-names">Sample ID</Label>
                                                    <Input className="edit-input-values" type="text" name="SampleId" size="10" disabled value={this.state.sample_id} />
                                                </Col>
                                                <Col>
                                                    <Label className="edit-label-names">Barcode </Label>
                                                    <Input className="edit-input-values" type="text" name="editbarcode" onChange={this.handleChange} size="10" value={this.state.editbarcode} />
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Row form>
                                                <Col md={6}>
                                                    <Label className="edit-label-names">Location ID</Label>
                                                    <Input className="edit-input-values" type="text" name="locationId" size="10" disabled={this.state.edit} value={this.state.editlocation_id} />
                                                </Col>
                                                <Col md={1.5}>
                                                    <Label className="edit-label-names" >Date & Time <span className="required-icon">*</span></Label>
                                                    <div>
                                                        <DatePicker
                                                            className="form-control edit-input-values edit-date-time"
                                                            onChange={this.onChangeDate} selected={this.state.editdate_time}
                                                            filterDate={(date) => {
                                                                return moment() > date;
                                                            }}
                                                            maxDate={new Date()}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            showTimeSelect
                                                            timeFormat="HH:mm"
                                                            timeIntervals={15}
                                                            timeCaption="time"
                                                            dateFormat="MMMM d, yyyy HH:mm" />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Row form>
                                                <Col>
                                                    <Label className="edit-label-names">Location Description </Label>
                                                    <Input className="edit-input-values" type="text" name="locationDescription" disabled={this.state.edit} size="10" value={this.state.editlocation} />
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Row form>
                                                <Col >
                                                    <Label className="edit-label-names">Unit </Label>
                                                    <Input className="edit-input-values" type="select" name="editunit" value={this.state.editunit} onChange={this.handleChange} size="1">
                                                        <option value="" default disabled>Select Unit</option>
                                                        {this.state.unitList ? this.state.unitList.map((unit, key) => {
                                                            return <option key={key} value={unit.id}>{unit.description}</option>
                                                        }) : null}
                                                    </Input>
                                                </Col>
                                                <Col>
                                                    <Label className="edit-label-names">Organism <span className="required-icon">*</span></Label>
                                                    <Input className="edit-input-values" type="text" name="editOrganism" size="10" value={this.state.editOrganism} onChange={this.handleChange} placeholder="Enter Organism" />
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Row form>
                                                <Col>
                                                    <Label className="edit-label-names">Type of Analysis</Label>
                                                    <Input className="edit-select-input" id="type-of-analysis" type="select" name="edittypeofAnalysis" value={this.state.edittypeofAnalysis} onChange={this.handleChange}>
                                                        <option value="" default>Type of Analysis</option>
                                                        <option value="SNP">SNP</option>
                                                        <option value="cgMLST">cgMLST</option>
                                                        <option value="Other" >Other</option>
                                                    </Input>
                                                </Col>
                                                <Col>
                                                    <Label className="edit-label-names">Reference Genome  <span className="required-icon">*</span></Label>
                                                    <Input disabled={this.state.edittypeofAnalysis !== "SNP"} type="text" name="editreferenceGenome" className='edit-input-values' size="10" value={this.state.edittypeofAnalysis === "SNP" ? this.state.editreferenceGenome : ""} onChange={this.handleChange} placeholder="Reference Genome *" />
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Row form>
                                                <Col>
                                                    <Label className="edit-label-names">Type of Sample</Label>
                                                    <Input className="edit-input-values" type="text" name="edittypeofSamples" id="type-of-sample" size="10" value={this.state.edittypeofSamples} onChange={this.handleChange} placeholder="Enter Sample Type" />
                                                </Col>
                                                <Col>
                                                    <Label className="edit-label-names">Batch Number</Label>
                                                    <Input className="edit-input-values" type="text" name="editbatchNumber" id="batchNo" size="10" value={this.state.editbatchNumber} onChange={this.handleChange} placeholder="Enter Batch Number" />
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Label className="edit-label-names">Comments</Label>
                                            <Input type="textarea" name="editComments" className="edit-input-values" size="10" value={this.state.editComments} onChange={this.handleChange} placeholder="Enter Comments" />
                                        </div>
                                        <div>
                                            <Label className="edit-label-names">Upload Image</Label>
                                            <Input
                                                className="edit-input-values edit-input-values-file"
                                                type="file"
                                                accept="image/jpeg, image/png"
                                                placeholder="please enter file"
                                                onChange={(e) => this.handleEditFileChange(e)}
                                                data-title={this.state.editfileName || 'Upload Image'}
                                            ></Input>
                                        </div>
                                    </FormGroup>
                                </Form>
                                <div className="justify-content-between">
                                    {this.state.type === "sample" ?
                                        <Button className="button-modal" outline color="danger" id={"deleteButton"} onClick={(e) => this.handleButtonClick(e)} >Delete
                                        <FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                                        </Button> : null}
                                    <div className="float-right ml-auto">
                                        <Button className="button-cancel mr-2" outline color="secondary" type="reset" onClick={this.toggleEditModal}>Cancel</Button>
                                        <Button className="save-upload-delete-button button-size" id="saveBtn" type="submit" onClick={this.handleEditBarcode}>Save</Button>
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>
                        <Modal isOpen={this.state.isEditBarcodeModelOpen} toggle={this.toggleEditBarcodeModal}>
                            <ModalHeader toggle={this.toggleEditBarcodeModal} className="edit-popup">Edit a Sample</ModalHeader>
                            <ModalBody>
                                {this.state.warningMessage}
                            <div className="float-sm-right mt-3">
                                    <Button className="custom-button cancel-button mr-2" outline color="secondary" onClick={this.toggleEditBarcodeModal}>Cancel</Button>
                                    <Button id="deleteButton" className="custom-button save-upload-delete-button" onClick={this.saveData}>Proceed</Button>
                                </div>
                            </ModalBody>
                        </Modal>
                    </div>
                </ModalBody>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        sampleList: state.sample_data.sampleList,
        locationList: state.sample_data.locationList,
        samplePagination: state.sample_data.allPagination
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchSamplesList,
        fetchLocationList,
        saveSample,
        updateSample,
        deleteMultipleSamples,
        getLocation
    }
)(OverLay), 'Samples Overlay', 'OverLay');